export default {
  SET_CLIENT_CONTENT(state, payload) {
    state.head = payload.result.head;
    state.header = payload.result.header;
    state.clientContext = payload.result.clientContext;
    state.megaMenu = payload.result.megamenu;
    state.footer = payload.result.footer;
  }
};
